//
// bigpicture.js
//

import BigPicture from 'bigpicture';

// Tous les éléments cliquables
const toggles = document.querySelectorAll('[data-bigpicture]');

// Helper: construit la galerie à partir d'une NodeList de toggles
function buildGalleryItems(nodeList) {
  return Array.from(nodeList).map(el => {
    let opts = {};
    try {
      opts = el.dataset.bigpicture ? JSON.parse(el.dataset.bigpicture) : {};
    } catch (_) {}
    const img = el.querySelector('img');
    return {
      // BigPicture attend { src, caption? } pour une galerie
      src: opts.imgSrc || (img ? img.src : ''),
      caption: el.dataset.caption || (img ? img.alt || '' : '')
    };
  });
}

toggles.forEach(function (toggle) {
  toggle.addEventListener('click', function (e) {
    e.preventDefault();

    // Si tu utilises data-bp-group, on limite la galerie au groupe cliqué
    const group = toggle.dataset.bpGroup;
    const groupSelector = group
      ? `[data-bigpicture][data-bp-group="${group}"]`
      : '[data-bigpicture]';

    const groupToggles = document.querySelectorAll(groupSelector);

    // Construit la liste { src, caption } pour la galerie
    const galleryItems = buildGalleryItems(groupToggles);

    // Trouve l'index de l’élément courant dans ce groupe
    const position = Array.from(groupToggles).indexOf(toggle);

    // Options par défaut
    const defaultOptions = {
      el: toggle,
      noLoader: true,
      // active la navigation
      gallery: galleryItems,
      position,
      loop: true // (optionnel) boucle de la dernière à la première
    };

    // Si jamais tu veux conserver des options individuelles supplémentaires :
    let elementOptions = {};
    try {
      elementOptions = toggle.dataset.bigpicture
        ? JSON.parse(toggle.dataset.bigpicture)
        : {};
    } catch (_) {}

    // Lance BigPicture
    BigPicture({ ...defaultOptions, ...elementOptions });
  });
});

// Optionnel : accès global
window.BigPicture = BigPicture;
